module.exports = __webpack_public_path__ + "img/youka.7935e89d.jpg";